import React, { useEffect, useState, useRef } from 'react';
import axios from '../api/axiosConfig';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf'; 

export default function UnpaidReport(){
  const [rows, setRows] = useState([]);
  const containerRef = useRef();

  useEffect(()=>{
    (async ()=>{
      const r = await axios.get('/members/unpaid');
      setRows(r.data || []);
    })();
  },[]);

  const exportCSV = () => {
    const headers = ['memberId','name','dueAmount','lastDueMonth'];
    const csv = [headers.join(','),
      ...rows.map(r => [r.memberId, `"${r.name}"`, r.dueAmount, r.lastDueMonth].join(','))
    ].join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = `unpaid_${Date.now()}.csv`; a.click();
    URL.revokeObjectURL(url);
  };

  const printPdf = async () => {
    const canvas = await html2canvas(containerRef.current);
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p','mm','a4');
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(`unpaid_${Date.now()}.pdf`);
  };

  return (
    < >
    <div className="container" style={{marginTop:24}}>
      <h5>Unpaid Members</h5>
      <div style={{marginBottom:12}}>
        <button className="btn" onClick={exportCSV}>Export CSV</button>
        <button className="btn" style={{marginLeft:8}} onClick={printPdf}>Export PDF</button>
      </div>

      <div ref={containerRef}>
        <table className="striped">
          <thead><tr><th>ID</th><th>Name</th><th>Amount Due</th><th>Last Due</th></tr></thead>
          <tbody>
            {rows.map(r=>(
              <tr key={r.memberId}>
                <td>{r.memberId}</td>
                <td>{r.name}</td>
                <td>{r.dueAmount}</td>
                <td>{r.lastDueMonth}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
    </ >
  );
}
